import React, { useState } from 'react';
import SimpleModal from '../../../components/Modals/SimpleModal';
import {Grid, Typography
} from '@mui/material'
import { green } from '@mui/material/colors';
import { useEffect } from 'react';
import AddressOption from '../components/AddressOption';
import GoogleMapSection from '../components/GoogleMapSection';
import {makeStyles} from '@mui/styles'
import ContainedButton from '../../../components/actions/ContainedButton';


/**
 * @module Layouts/Registration/modals/AddressAdjustmentModal
 * @description This is a React component that renders a modal for confirming an address selection and includes a
 * Google Map section.
 */

/**
 * 
 * @typedef AddressAdjustmentModal
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Boolean} open - Variables that handles if this component is shown or not
 * @property {Array<Object>} addresses - List of addresses elements retrived from Smarty API address
 * @property {Boolean} selected - Variable that handles if an address is selected or not
 * @property {Function} onEnrollCardholder - This function is dispatched to start Cardholder's Enrollment Process
 * @property {Function} onClose - This function closes this Component Modal
 
 */
const AddressAdjustmentModal = (props) => {

    const classes = useStyles()
    const {open, onClose, onResetForm, addresses, onEnrollCardholder, sending} = props

    const [selected, setSelected] = useState()

    /* This `useEffect` hook is setting the initial value of the `selected` state variable to the first
    address in the `addresses` array when the modal is opened and the `addresses` array is not
    empty. It runs whenever the `open` or `addresses` variables change. */
    useEffect(() => {
        if(open && addresses.length){
            setSelected(addresses[0])
        }
    }, [open, addresses])

    /**
     * The function `onInnerClose` calls `onClose` and potentially `onResetForm`.
     */
    const onInnerClose = () => {
        //onResetForm()
        onClose()
    }

    const addressPoint =  selected ? {
        latitude:selected?.metadata?.latitude,
        longitude:selected?.metadata?.longitude
    } : null


    return ( 
        <SimpleModal open={open} onClose={onInnerClose} maxWidth='sm'>
            <div className={classes.root}>
                <Grid container justifyContent='center' spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant='h6' className={classes.title}>Address Confirmation</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>We have found the following address(es) according to your data</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.menu}>
                            <Grid container spacing={2}>
                                {addresses.map(item=> {
                                    return(
                                        <Grid item xs={12} key={`address-${item.candidate_index}`}>
                                            <AddressOption 
                                                address={item} 
                                                selected={selected?.candidate_index === item?.candidate_index}
                                                onSelected={(val) => setSelected(val)}/>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </div>
                        <div className={classes.menu}>
                            <GoogleMapSection address={addressPoint} />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <ContainedButton loading={sending} fullWidth color='primaryDark' onClick={() => onEnrollCardholder(selected)}>CONFIRM</ContainedButton>
                    </Grid>
                </Grid>
            </div>
        </SimpleModal>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        //paddingTop:30
    },
    title:{
        fontWeight:600,
    },
    icon_container:{
        width:80,
        height:80,
        borderRadius:'50%',
        border:`1px solid ${green[700]}`,
        position:'relative'
    },
    icon:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)',
        color:green[700],
        fontSize:48
    },
    menu:{
        margin:'16px 0px'
    }
}))
 
export default AddressAdjustmentModal;